import {
  Box,
  Grid,
  GridItem,
  Stack,
  Text,
  Link,
  Divider,
  useColorModeValue,
  Flex,
  Collapse,
  useDisclosure,
} from '@chakra-ui/react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContextAuth } from '../../contexts/Authentication';
import { IoIosArrowDown } from 'react-icons/io';

const CandidateInfo: React.FC = () => {
  const navigate = useNavigate();
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const cardBg = useColorModeValue('white', 'gray.800');
  const labelColor = useColorModeValue('gray.600', 'gray.400');

  const { candidate, signOut } = useContext(ContextAuth);

  if (!candidate) return;

  const InfoItem = ({ label, value }: { label: string; value?: string }) => (
    <Stack spacing={0}>
      <Text fontSize="xs" color={labelColor}>
        {label}
      </Text>
      <Text fontSize="sm" fontWeight="medium">
        {value || '--'}
      </Text>
    </Stack>
  );

  return (
    <Box w="100%" px={6} py={3} bg={cardBg} rounded="lg" shadow="md">
      <Flex justify="space-between" align="center" onClick={onToggle}>
        <Text fontSize="md" fontWeight="bold">
          Dados Pessoais
        </Text>
        <Box transform={`rotate(${isOpen ? '180deg' : '0deg'})`} transition="0.4s">
          <IoIosArrowDown size={19} />
        </Box>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Grid mt={3} templateColumns={['1fr', null, '1fr 1fr']} gap={2}>
          <GridItem>
            <Stack spacing={2}>
              <InfoItem label="Nome completo" value={candidate?.user?.full_name} />
              <Stack spacing={0}>
                <Text fontSize="xs" color={labelColor}>
                  {candidate?.is_foreign ? 'Passaporte' : 'CPF'}{' '}
                </Text>
                <Text fontSize="sm" fontWeight="medium">
                  {candidate.is_foreign ? candidate.passport_number || '--' : candidate?.cpf || '--'}
                </Text>
                <Text fontSize="xs" color="gray.500">
                  Não é seu {candidate?.is_foreign ? 'passaporte?' : 'CPF?'}{' '}
                  <Link
                    color="blue.500"
                    onClick={() => {
                      signOut();
                      navigate('/');
                    }}
                  >
                    clique aqui
                  </Link>
                </Text>
              </Stack>
              <InfoItem label="Data de nascimento" value={candidate?.date_of_birth?.br} />
              <InfoItem label="E-mail" value={candidate?.user?.email} />
              {!candidate.is_foreign && (
                <InfoItem
                  label={candidate?.document_type?.name || 'Documento'}
                  value={`${candidate?.document_number || '--'} ${
                    candidate?.document_issuing_body || ''
                  } ${candidate?.document_issuing_body_uf?.initials || ''}`}
                />
              )}
              <InfoItem label="Sexo" value={candidate?.gender?.name} />
            </Stack>
          </GridItem>
          <GridItem>
            <Stack spacing={3}>
              <InfoItem label="CEP" value={candidate?.address_zip_code} />
              <InfoItem label="Endereço" value={candidate?.address_street} />
              <InfoItem label="Número" value={candidate?.address_number} />
              <InfoItem label="Complemento" value={candidate?.address_complement} />
              <InfoItem label="Bairro" value={candidate?.address_neighborhood} />
              <InfoItem label="Cidade" value={candidate?.address_city?.name || '--'} />
              <InfoItem label="Estado" value={candidate?.address_state?.initials || '--'} />
              <InfoItem label="Telefone" value={candidate?.phone} />
              <InfoItem label="Celular" value={candidate?.cellphone} />
            </Stack>
          </GridItem>
        </Grid>
        <Divider my={4} />
        <Box mb={2}>
          <Text fontSize="sm">
            <Text as="span" fontWeight="bold" color="red.500">
              ATENÇÃO:{' '}
            </Text>
            Os dados acima estão incorretos? Caso estejam,{' '}
            <Link onClick={() => navigate('/painel/meus-dados')} color="blue.500" fontWeight="medium">
              clique aqui
            </Link>{' '}
            e atualize seu cadastro.
          </Text>
        </Box>
      </Collapse>
    </Box>
  );
};

export default CandidateInfo;
